import Field from "csi/def/Field";
import Widget from "csi/form/Widget";
import { ATTR_NAME } from "csi/typings";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
const NameLinkedSizeChartsForm = declare(Widget, {

	FIELD_SIZE_CHART_NAME: "SizeChartName",

	_resolveView() {
		this.inherited(arguments);
		const ctx = this.getContext();
		const shape = ctx.getNode();
		this.addFixedValue("ShapeSizeChart", shape[ATTR_NAME]);
		const linkedBomNameField = this.insertField(lang.mixin(new Field(), {
		    m_bRequired: true,
			m_label: this.FIELD_SIZE_CHART_NAME,
		}));
	},
});
export = NameLinkedSizeChartsForm;